import React, { useEffect, useState } from 'react';
import FaqPiece from './faq-piece';
import {
  LearningInfo,
  sellerLearningCenterApiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { useContextUser } from '@features/hooks';
import { CODE_SUCCESS } from '@features/constants/network';
import ErrorPage from '@features/components/error-page';
import { i18n, useTranslation } from '@jupiter-app/plugin-i18n';
import { Tea } from '@features/libs/tea';
import { useUserModel } from '@/models';
import { getPopReportQuery } from '@/hooks/usePopQuery';

export const Faq = () => {
  const [user] = useContextUser();
  const [error, setError] = useState(false);
  const [faqData, setFaqData] = useState<Array<LearningInfo>>();
  const [faqErr, setFaqErr] = useState(false);
  const { isCreator, isSeller } = useUserModel();
  const { t } = useTranslation();

  const getHomePageData = () => {
    setError(false);
    setFaqErr(false);
    sellerLearningCenterApiClient
      .GetHomeFaq({})
      .then(faqRes => {
        if (faqRes.code === CODE_SUCCESS) {
          setFaqData(faqRes?.learning_info);
        } else {
          setFaqErr(true);
        }
        if (faqRes.code !== CODE_SUCCESS) {
          setError(true);
        }
      })
      .catch(e => {
        console.log(e);
        setError(true);
      });
  };

  const errorText = {
    title: 'academy_load_fail_page_title',
    text: 'academy_load_fail_page_text',
    buttonText: 'academy_load_fail_page_btn',
    buttonClick: getHomePageData,
  };

  useEffect(() => {
    getHomePageData();
  }, [i18n.language]);

  useEffect(() => {
    const startTimeMs = new Date().getTime();
    Tea('page_show', {
      is_login: user.user_id ? '1' : '0',
      page_name: 'seller_university_homepage',
      type: 'page',
      url: window.location.href,
      identity_type: isCreator ? 'creator' : isSeller ? 'seller' : '',
      prev_page_name: window.document.referrer,
      ...getPopReportQuery(),
    });

    const reportDuration = () => {
      Tea.pageDuration({
        page_name: 'seller_university_homepage',
        duration: new Date().getTime() - startTimeMs,
        is_login: user.user_id ? '1' : '0',
        identity_type: isCreator ? 'creator' : isSeller ? 'seller' : '',
        prev_page_name: window.document.referrer,
        url: window.location.href,
        ...getPopReportQuery(),
      });
    };

    window.addEventListener('beforeunload', reportDuration);

    return () => {
      reportDuration();
      window.removeEventListener('beforeunload', reportDuration);
    };
  }, []);

  return (
    <div className="flex bg-[#f6f6f6] flex-col items-center">
      {error ? (
        <div
          className="w-full flex justify-center items-center h-full"
          style={{ height: 'calc(100vh - 500px)' }}>
          <ErrorPage
            hasNewVersion={true}
            title={t(errorText.title)}
            text={t(errorText.text)}
            leftButton={{
              type: 'primary',
              text: t(errorText.buttonText),
              onClick: errorText.buttonClick,
            }}
          />
        </div>
      ) : (
        <FaqPiece faqData={faqData} error={faqErr} />
      )}
    </div>
  );
};
